export var SET_USER_TYPE = 'SET_USER_TYPE';
export var SET_AS_POWER_USER = 'SET_AS_POWER_USER';
export var setUserType = function (payload) { return ({
    type: SET_USER_TYPE,
    payload: payload
}); };
export var setAsPowerUser = function (payload) { return ({
    type: SET_AS_POWER_USER,
    payload: payload
}); };
